import React, { useState } from 'react';
import { Button } from '../Button';
import { Select } from '../Select';
import './MorphButton.css';

/**
 * An animated toggle button that expands into a multi-select search panel.
 * Manages its own open/closed state. Fixed Select props (isMulti, isClearable,
 * showMultiSelectedElements, label) are hardcoded; callers supply only data-specific props.
 *
 * @param {object} props
 * @param {string} props.name - The Select field name
 * @param {Array<{value, label}>} props.value - Currently selected items
 * @param {Array} props.options - Available options for the Select
 * @param {Function} props.onChange - Called when a selection changes
 * @param {string} [props.placeholder] - Select placeholder text
 * @param {Function} [props.onInputChange] - Called on search input change (async search)
 * @param {Function} [props.loadMoreOptions] - Load next page of results (async search)
 * @param {boolean} [props.loading] - Whether more options are loading
 * @param {number} [props.resultCount] - Total result count for async search
 * @param {string} [props.searchTerm] - Current search term for async search
 * @param {Function} [props.clearSearchResults] - Clears async search results on close
 * @param {Function} [props.onToggle] - Optional side-effect callback fired on every toggle
 */
export function MorphButton({
  name,
  value,
  options,
  onChange,
  placeholder,
  onInputChange,
  loadMoreOptions,
  loading,
  resultCount,
  searchTerm,
  clearSearchResults,
  onToggle,
}) {
  const [isOpen, setIsOpen] = useState(false);

  /** Toggles the panel and fires the optional parent side-effect. */
  const handleToggle = () => {
    setIsOpen(prev => !prev);
    if (onToggle) onToggle();
  };

  return (
    <div className={'morph-button-wrapper ' + (isOpen ? 'show' : '')}>
      <div className="morph-button-content">
        <form className="form" onSubmit={e => e.preventDefault()}>
          <Select
            name={name}
            label={false}
            value={value}
            options={options}
            onInputChange={onInputChange}
            loadMoreOptions={loadMoreOptions}
            loading={loading}
            resultCount={resultCount}
            searchTerm={searchTerm}
            clearSearchResults={clearSearchResults}
            placeholder={placeholder}
            isMulti={true}
            isClearable={true}
            showMultiSelectedElements={false}
            onChange={onChange}
            onBlur={handleToggle}
            setFocus={isOpen}
          />
        </form>
      </div>
      <Button
        buttonStyle="main-button"
        className="morph-button-toggle main-toolbar-item"
        onClick={handleToggle}
        value="+ ADD"
      />
    </div>
  );
}
